import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Modal } from "antd";
import { DisplayError } from "./ErrorModal";

interface IErrorProps {
  title?: string;
  error: string | FetchBaseQueryError | SerializedError;
  onOk?: () => void;
}

const Error = ({ title, error, onOk }: IErrorProps) => {
  return Modal.error({
    title: title,
    content: <DisplayError error={error} />,
    onOk: onOk,
  });
};

export default Error;
